import { Navigate, useNavigate } from 'react-router-dom';
import { login } from '../api/portal';
import { ApiError } from '../api/client';
import { useAuthStore } from '../stores/auth';
import { LoginShell } from '../components/LoginShell';

export function LoginPage() {
  const token = useAuthStore((s) => s.accessToken);
  const setSession = useAuthStore((s) => s.setSession);
  const navigate = useNavigate();

  if (token) return <Navigate to="/matches" replace />;

  return (
    <LoginShell
      product="Portal"
      headline={<>Official data, <span className="text-accent">live from the source.</span></>}
      lede="Play-by-play, stats, clips and highlight reels for your league, club or newsroom."
      highlights={[
        { title: 'Live play-by-play', body: 'Every event scouted courtside and QC-checked in seconds.' },
        { title: 'Clips & highlights', body: 'Auto-cut reels in 16:9 and 9:16, ready to publish.' },
        { title: 'Widgets & API', body: 'Embed scoreboards or pull the feed straight into your stack.' },
      ]}
      footnote={
        <>
          Need an account or help signing in?{' '}
          <a href="mailto:support@origo.rs" className="font-medium text-accent hover:underline">
            support@origo.rs
          </a>
        </>
      }
      initialEmail={import.meta.env.DEV ? 'demo@client.local' : ''}
      initialPassword={import.meta.env.DEV ? 'client_local_pw' : ''}
      onLogin={async (email, password) => {
        const res = await login(email, password);
        setSession(res.access_token, res.expires_at, res.client);
        navigate('/matches', { replace: true });
      }}
      describeError={(err) => (err instanceof ApiError ? err.message : String(err))}
    />
  );
}
